import { ENRICHMENT_CATEGORY_TYPE_PROFILE } from 'common-data-handling';
import React from 'react';
import ActionButton from '../../../../../elements/ActionButton/ActionButton';
import { useEnrichmentQuestions } from '../../../../../../data/hooks/enrichments/useEnrichmentQuestions';

export function ProfileEnrichment(props) {
    let { i18n, event } = props,
        ecat = _(event.enrichment_categories)
            .values()
            .find((ecat) => ecat.category == ENRICHMENT_CATEGORY_TYPE_PROFILE),
        openQuestions = useEnrichmentQuestions(event.id, {
            filter: (q) => q.question.category == ENRICHMENT_CATEGORY_TYPE_PROFILE && !q.answer.length,
        });

    const hasOpenQuestions = ecat?.open_count || openQuestions.length > 0;

    if (!ecat) return null;
    if (!ecat.label) return null;
    if (!hasOpenQuestions && ecat.visibility != 1) return null;

    return (
        <ActionButton
            href={'./enrich/' + ecat.category}
            style={{
                textTransform: 'capitalize',
            }}
            secondary
            next
            small>
            {ecat.label}
        </ActionButton>
    );
}
